function getApiBaseUrl(): string {
  // Se tem variável de ambiente, usa ela (produção)
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }

  // Em dev, o proxy do Vite redireciona /v1 → API
  // Em produção, detecta pelo hostname
  const hostname = window.location.hostname

  // Localhost ou IP local → proxy do Vite (dev)
  if (hostname === 'localhost' || hostname.startsWith('192.168') || hostname.startsWith('10.')) {
    return ''
  }

  // comunidade.sispoli.local → proxy do Vite (dev com nginx)
  if (hostname.endsWith('.sispoli.local')) {
    return ''
  }

  // comunidade.sispoli.com.br → API de produção
  if (hostname.endsWith('.sispoli.com.br')) {
    return 'https://api.sispoli.com.br'
  }

  // Fallback
  return ''
}

export const API_BASE_URL = getApiBaseUrl()

export function apiUrl(path: string): string {
  return `${API_BASE_URL}${path}`
}

/** Headers padrão para chamadas autenticadas — inclui token + slug da org */
export function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('token') || ''
  const slug = window.location.pathname.split('/')[1] || ''
  return {
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
    'X-Community-Slug': slug,
  }
}

/**
 * Intercepta TODAS as chamadas fetch pra API e injeta o header X-Community-Slug.
 * Garante isolamento multi-tenant mesmo que o código esqueça de enviar.
 */
const _originalFetch = window.fetch
window.fetch = function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url
  const isApi = url.includes('/v1/') || url.startsWith(API_BASE_URL)

  if (isApi) {
    const slug = window.location.pathname.split('/')[1] || ''
    const headers = new Headers(init?.headers)
    if (slug && !headers.has('X-Community-Slug')) {
      headers.set('X-Community-Slug', slug)
    }
    return _originalFetch.call(window, input, { ...init, headers })
  }

  return _originalFetch.call(window, input, init)
}
